export enum LOCAL_STORAGE {
  DEPOSIT_MODAL_DATA = 'bum_deposit_modal_data',
  DEPOSIT_MODAL_AUTO_OPEN = 'bum_deposit_modal_auto_open',
  REGISTRATION_MODAL_DATA = 'bum_register_modal_data',
  REGISTRATION_MODAL_AUTO_OPEN = 'bum_register_modal_auto_open',
  REGISTRATION_SUCCESS = 'bum_register_success',
  BONUS_MODAL_DATA = 'bum_bonus_modal_data',
  BONUS_MODAL_AUTO_OPEN = 'bum_bonus_modal_auto_open',
  BONUS_SUCCESS = 'bum_bonus_success',
  CLARITY_CONSENT = 'bum_clarity_cookie_consent'
}